module.exports = __webpack_public_path__ + "img/138.70b970ac.jpg";